import React, { useMemo, useRef, useState } from 'react'
import useOnClickOutside from 'use-onclickoutside'
import View from './view.js'

export default function Logic(props) {
  let [isShowingOptions, setIsShowingOptions] = useState(false)
  let [valueFilter, setValueFilter] = useState('')
  let optionsRef = useRef(null)
  useOnClickOutside(optionsRef, () => setIsShowingOptions(false))

  let fromValues = useMemo(() => {
    if (valueFilter === '') return props.from

    let valueFilterRegex = new RegExp(valueFilter, 'i')
    return props.from.filter(item => valueFilterRegex.test(item.text))
  }, [props.from, valueFilter])

  let placeholder =
    props.placeholder ||
    (props.value?.length > 0 ? `${props.value.length} selected` : undefined)

  return (
    <View
      {...props}
      from={fromValues}
      isShowingOptions={isShowingOptions}
      optionsRef={optionsRef}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyUp={onKeyUp}
      onClick={onClick}
      placeholder={placeholder}
      isSelected={isSelected}
      onChangeFilter={onChangeFilter}
      valueFilter={valueFilter}
    />
  )

  function onChangeFilter(event, value) {
    setValueFilter(value)
  }

  function onClick(id) {
    if (typeof props.onChange !== 'function') return

    if (isSelected({ id })) {
      props.onChange(props.value.filter(item => item !== id))
    } else {
      props.onChange([...props.value, id])
    }
  }

  function isSelected(item) {
    return props.value?.some(vid => vid === getId(item))
  }

  function getId(item) {
    return props.id ? item[props.id] : item.id ?? item._id
  }

  function onKeyUp(event) {
    if (props.onKeyUp) {
      props.onKeyUp(event)
    } else if (event.key === 'Enter' && typeof props.onSubmit === 'function') {
      props.onSubmit()
    } else if (event.key === 'Escape') {
      setIsShowingOptions(false)
    }
  }

  function onFocus(event) {
    if (props.disabled) return

    setIsShowingOptions(true)
    if (typeof props.onFocus === 'function') {
      props.onFocus(event)
    }
  }

  function onBlur(event) {
    if (
      !(
        event.relatedTarget === optionsRef.current ||
        optionsRef.current?.contains(event.relatedTarget)
      )
    ) {
      setIsShowingOptions(false)
    }
    if (typeof props.onBlur === 'function') {
      props.onBlur(event)
    }
  }
}
